'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseMenu = require('../BaseMenu');

var _BaseMenu2 = _interopRequireDefault(_BaseMenu);

var _Favorite = require('../Favorite');

var _Favorite2 = _interopRequireDefault(_Favorite);

var _GoogleDFP = require('../GoogleDFP');

var _GoogleDFP2 = _interopRequireDefault(_GoogleDFP);

var _adConfig = require('../helpers/adConfig');

var _adConfig2 = _interopRequireDefault(_adConfig);

var _getAddFavoritesHref = require('../helpers/getAddFavoritesHref');

var _getAddFavoritesHref2 = _interopRequireDefault(_getAddFavoritesHref);

var _favoritesPropType = require('../PropTypes/favoritesPropType');

var _favoritesPropType2 = _interopRequireDefault(_favoritesPropType);

var _windowPropType = require('../PropTypes/windowPropType');

var _windowPropType2 = _interopRequireDefault(_windowPropType);

var _settingsPropType = require('../PropTypes/settingsPropType');

var _settingsPropType2 = _interopRequireDefault(_settingsPropType);

var _userPropType = require('../PropTypes/userPropType');

var _userPropType2 = _interopRequireDefault(_userPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavoritesMenu = function FavoritesMenu(_ref) {
  var favorites = _ref.favorites,
      settings = _ref.settings,
      user = _ref.user,
      window = _ref.window,
      onClickLink = _ref.onClickLink;
  return _react2.default.createElement(
    _BaseMenu2.default,
    null,
    _react2.default.createElement(
      'div',
      { className: 'quiver-favorites-menu__links' },
      _react2.default.createElement(
        'a',
        {
          className: 'quiver-favorites-menu__links-add',
          href: (0, _getAddFavoritesHref2.default)(window ? window.location.href : null),
          onClick: onClickLink
        },
        'Add Favorites'
      ),
      user && favorites.length ? _react2.default.createElement(
        'a',
        {
          className: 'quiver-favorites-menu__links-edit',
          href: '/account/favorites',
          onClick: onClickLink
        },
        'Edit Favorites'
      ) : null
    ),
    _react2.default.createElement(
      'div',
      { className: 'quiver-favorites-menu__favorites' },
      favorites.map(function (favorite) {
        return _react2.default.createElement(_Favorite2.default, {
          key: favorite._id,
          favorite: favorite,
          settings: settings,
          onClickLink: onClickLink,
          large: true,
          mobile: true
        });
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'quiver-favorites-menu__ad' },
      _react2.default.createElement(_GoogleDFP2.default, { adConfig: (0, _adConfig2.default)('favoritesHorizontal') })
    )
  );
};

FavoritesMenu.propTypes = {
  user: _userPropType2.default,
  favorites: _favoritesPropType2.default,
  settings: _settingsPropType2.default,
  onClickLink: _propTypes2.default.func,
  window: _windowPropType2.default
};

FavoritesMenu.defaultProps = {
  favorites: [],
  settings: null,
  user: null,
  onClickLink: null
};

exports.default = FavoritesMenu;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/FavoritesMenu/FavoritesMenu.js
// module id = 580
// module chunks = 11